import React from 'react';
import { Button } from './ui/Button';
import { Check, ShieldCheck, FileText } from 'lucide-react';
import { ImageCarousel } from './ImageCarousel';
const CAROUSEL_IMAGES = ['https://cdn.magicpatterns.com/uploads/6AppQmvYViPUyJbg1yJhFi/COVER_TDLO360.png', 'https://cdn.magicpatterns.com/uploads/1CRFthEPrgL59saERFAED2/COVER_NTICX360.png', 'https://cdn.magicpatterns.com/uploads/kNeKvdPQuC1dG65EYqLnn7/Cover_SIC_360.png', 'https://cdn.magicpatterns.com/uploads/czVbuere1YYeoYWzxPys3n/conver_micro_y_macro.png'];
export function MegapackSection() {
  return <section className="py-12 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-128">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-129"></div>

      {/* Megapack Badge */}
      <div className="max-w-md mx-auto relative z-10 mb-8 text-center" data-id="element-130">
        <div className="inline-block bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-2 rounded-full font-black text-sm uppercase tracking-wide shadow-xl" data-id="element-131">
          🔥 OFERTA ESPECIAL - PACK FULL
        </div>
        <h2 className="text-2xl md:text-3xl font-bold mt-4 mb-2" data-id="element-132">
          MEGAPACK COMERCIAL CONTABLE 360
        </h2>
        <p className="text-blue-200 text-sm" data-id="element-133">
          Llevate el megapack completo de secundario comercial contable con
          clases listas resueltas para todo el año
        </p>
      </div>

      <div className="max-w-md mx-auto relative z-10" data-id="element-134">
        <div className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden border-4 border-orange-500" data-id="element-135">
          {/* Carousel Section */}
          <div className="bg-gradient-to-b from-gray-50 to-white p-6" data-id="element-136">
            <ImageCarousel images={CAROUSEL_IMAGES} data-id="element-137" />
          </div>

          {/* Price Section */}
          <div className="px-6 py-8 text-center border-b border-gray-100" data-id="element-138">
            <p className="text-gray-400 text-sm font-semibold uppercase tracking-wider mb-2" data-id="element-139">
              Precio Pack Completo
            </p>
            <div className="mb-2" data-id="element-140">
              <span className="text-gray-400 text-2xl line-through" data-id="element-141">
                $89.990
              </span>
            </div>
            <div className="text-blue-900 font-black text-5xl mb-3" data-id="element-142">
              $49.990
            </div>
            <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full text-sm font-bold" data-id="element-143">
              Ahorrás $40.000 con el pack completo
            </div>
          </div>

          {/* Features Section */}
          <div className="px-6 py-6 space-y-4" data-id="element-144">
            {/* Feature 1 - Orange */}
            <div className="bg-orange-50 border border-orange-200 rounded-xl p-4 flex gap-3" data-id="element-145">
              <div className="flex-shrink-0 mt-1" data-id="element-146">
                <div className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center" data-id="element-147">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-148" />
                </div>
              </div>
              <div data-id="element-149">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-150">
                  4 Bonos Exclusivos (Gratis por hoy)
                </h4>
                <p className="text-sm text-gray-600" data-id="element-151">
                  Banco de ejemplos, clases express, evaluaciones listas y mapa
                  anual de contenidos
                </p>
              </div>
            </div>

            {/* Feature 2 - Blue */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 flex gap-3" data-id="element-152">
              <div className="flex-shrink-0 mt-1" data-id="element-153">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center" data-id="element-154">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-155" />
                </div>
              </div>
              <div data-id="element-156">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-157">
                  Acceso Inmediato y Vitalicio
                </h4>
                <p className="text-sm text-gray-600" data-id="element-158">
                  Descargá todo el material al instante y accedé cuando lo
                  necesites, sin vencimiento
                </p>
              </div>
            </div>

            {/* Feature 3 - Yellow with EXTRA badge */}
            <div className="bg-yellow-50 border-2 border-yellow-400 rounded-xl p-4 flex gap-3 relative" data-id="element-159">
              <div className="absolute -top-2 -right-2 bg-yellow-400 text-yellow-900 px-2 py-0.5 rounded-full text-xs font-black uppercase shadow-md" data-id="element-160">
                EXTRA
              </div>
              <div className="flex-shrink-0 mt-1" data-id="element-161">
                <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center" data-id="element-162">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-163" />
                </div>
              </div>
              <div data-id="element-164">
                <h4 className="font-bold text-gray-900 mb-1" data-id="element-165">
                  TEORIA DE LAS ORGANIZACIONES 360 + MICRO Y MACRO ECONOMÍA 360
                  + SIC 360 + NTICX 360
                </h4>
                <p className="text-sm text-gray-600" data-id="element-166">
                  Megapack comercial contable con clases resueltas para todo el
                  año
                </p>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="px-6 pb-6" data-id="element-167">
            <Button href="https://checkout.rincondigital.shop/cart/52921028411667:1" variant="primary" size="lg" fullWidth withArrow className="shadow-xl shadow-orange-500/30 text-base py-5 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600" data-id="element-168">
              ACCEDÉ AL MEGAPACK COMERCIAL CONTABLE 360
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="px-6 pb-6 flex items-center justify-center gap-6 text-sm text-gray-500" data-id="element-169">
            <div className="flex items-center gap-2" data-id="element-170">
              <ShieldCheck className="h-4 w-4 text-green-500" data-id="element-171" />
              <span data-id="element-172">Compra Segura</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-173">
              <FileText className="h-4 w-4 text-blue-500" data-id="element-174" />
              <span data-id="element-175">Material Digital</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}